import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Grid,
  Link as MuiLink,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import CONFIG from '../../config'
import Link from '../controls/Link'
import Logo from '../../../assets/images/logo/b_badge_stroked_dark.png'
import Logotype from '../../../assets/images/logo/blok_logotype@2x.png'

import * as AuthenticationActionCreators from '../../actions/authentication'

class TopNav extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    authActions: PropTypes.object.isRequired,
  }

  static mapStateToProps() {
    return {}
  }

  static mapDispatchToProps(dispatch) {
    return {
      authActions: bindActionCreators(AuthenticationActionCreators, dispatch),
    }
  }

  static styles = (theme) => ({
    logo: {
      height: 72,
    },
    logotype: {
      height: 72,
    },
    link: theme.introLink,
  })

  handleLogout = (e) => {
    this.props.authActions.logout(e)
  }

  render() {
    const { classes } = this.props

    return (
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Link to={CONFIG.blokable.marketingBaseUrl}>
            <img src={Logo} alt="Blokable" className={classes.logo} />
            <img src={Logotype} alt="Blokable" className={classes.logotype} />
          </Link>
        </Grid>
        <Grid item>
          <MuiLink href="#" onClick={this.handleLogout} className={classes.link}>
            Sign out
          </MuiLink>
        </Grid>
      </Grid>
    )
  }
}

export default connect(TopNav.mapStateToProps, TopNav.mapDispatchToProps)(withStyles(TopNav.styles)(TopNav))
